import React, { useState } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/react-hooks';
import { withRouter } from 'react-router-dom';
import Button from './Button';
import colors from '../styles/colors';
import { ACCEPT_ROLE } from '../graphql/queries';
import { getPostLoginPath } from '../util/postLoginRedirect';
import { FadeIn } from './Animation';
import { media } from '../util/MediaQuery';

const TopText = styled.div`
  font-size: 2rem;
  text-align: center;
  margin-top: 30px;
`;

const Content = styled.div`
  align-items: center;
  justify-content: center;
`;

const ContentContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  width: 100%; */
  display: flex;
  align-items: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  background: ${colors.white};

  border-radius: 5px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  margin: auto;
  overflow-y: auto;
  ${media.desktop`
    &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
    padding: 30px;
    width: 400px;
  `};

  ${media.mobile`
    height: 100vh;
    width: 100vw;
    padding: 10px;
  `};
  ${media.desktop`
    min-height: 85vh !important;
    max-height: 85vh !important; 
  `};
  ${media.tablet`
    min-height: 100vh;
    max-height: 100vh; 
  `};
`;

export const Image = styled.div`
  background-image: ${(props) => `url(${props.src})`};
  background-size: cover;
  background-position: center;
  background-origin: unset;
  border-radius: ${(props) => props.radius || '5px'};
  height: 230px;
  width: 100%;
`;

function RoleInvite({ history, roles }) {
  const [didAccept, setDidAccept] = useState(false);
  const [acceptRole] = useMutation(ACCEPT_ROLE, {
    onError(error) {
      console.error(error);
    },
    onCompleted(data) {
      if (didAccept) {
        console.log(data);
        localStorage.setItem('CHECK_THIS_OUT_AUTH_TOKEN', data.acceptRole.token);
        history.push(getPostLoginPath(roles[0].accessLevel));
      } else {
        // reload page from cache if available
        // to push user to the redeemCoupon page
        history.push('/redeemCoupon');
      }
    },
  });

  if (roles.length === 0) {
    history.replace('/redeemCoupon');
    return null;
  }

  const role = roles[0];
  const orgName = role.organization.name;
  const roleLabel = role.accessLevel === 'Admin'
    ? 'an Admin user'
    : role.accessLevel === 'Server'
      ? 'a Server'
      : role.accessLevel.toLowerCase();

  return (
    <Content>
      <ContentContainer>
        <FadeIn
          duration={0.6}
          height="100%"
        >
          <Image
            src={roles[0].organization.logoUrl}
          />
          <TopText>
            You have been invited to the <strong>{orgName}</strong> organization
            as <strong>{roleLabel}</strong>.
            <br />
            Would you like to accept this invitation?
          </TopText>
          <Button
            margin="80px 0px 0px 0px"
            text="ACCEPT INVITE"
            width="100%"
            onClick={() => {
              setDidAccept(true);
              acceptRole({
                variables: {
                  roleId: roles[0]._id,
                  doesAccept: true,
                  phoneCode: '1234',
                },
              });
            }}
          />
          <Button
            margin="10px 0px 0px 0px"
            text="DISMISS"
            background={colors.red}
            width="100%"
            onClick={() => acceptRole({
              variables: {
                roleId: roles[0]._id,
                doesAccept: false,
                phoneCode: '0000',
              },
            })}
          />
        </FadeIn>
      </ContentContainer>
    </Content>
  );
}

export default withRouter(RoleInvite);
